import type { SetUserDataProps } from "src/types";

export function captureApplicationIds(
  response: { application_id?: string; borrower_id?: string },
  setUserData: SetUserDataProps,
) {
  const keysToCheck = ["application_id", "borrower_id"] as const;
  const newState: Partial<Record<"application_id" | "borrower_id", string>> =
    {};

  for (const key of keysToCheck) {
    if (response[key]) {
      newState[key] = response[key];
    }
  }

  setUserData((prevState) => {
    const roles = prevState.roles || { coborrowers: [] };
    if (!roles.borrower && newState.borrower_id) {
      roles.borrower = newState.borrower_id;
    }
    if (
      roles.borrower &&
      newState.borrower_id &&
      newState.borrower_id.length > 0 &&
      newState.borrower_id !== roles.borrower &&
      !roles.coborrowers?.includes(newState.borrower_id)
    ) {
      roles.coborrowers?.push(newState.borrower_id);
    }
    return {
      ...prevState,
      ...newState,
      roles,
    };
  });
}
